import { isString, lastElement, sleep } from '@standardnotes/utils';
import { isErrorResponse } from '@standardnotes/responses';
import { AbstractService, } from '@standardnotes/services';
import { ContentType, SettingName } from '@standardnotes/domain-core';
export class ListedService extends AbstractService {
    constructor(apiService, itemManager, settingsService, httpSerivce, protectionService, mutator, sync, internalEventBus) {
        super(internalEventBus);
        this.apiService = apiService;
        this.itemManager = itemManager;
        this.settingsService = settingsService;
        this.httpSerivce = httpSerivce;
        this.protectionService = protectionService;
        this.mutator = mutator;
        this.sync = sync;
        this.internalEventBus = internalEventBus;
    }
    deinit() {
        ;
        this.itemManager = undefined;
        this.settingsService = undefined;
        this.apiService = undefined;
        this.httpSerivce = undefined;
        this.protectionService = undefined;
        this.mutator = undefined;
        super.deinit();
    }
    canRegisterNewListedAccount() {
        return this.apiService.user != undefined;
    }
    isNoteAuthorizedForListed(note) {
        return note.authorizedForListed;
    }
    async authorizeNoteForListed(note) {
        const result = await this.protectionService.authorizeListedPublishing();
        if (result === false) {
            return false;
        }
        await this.mutator.changeItem(note, (mutator) => {
            mutator.authorizedForListed = true;
        });
        void this.sync.sync();
        return true;
    }
    /**
     * Account creation is asyncronous on the backend due to message-based nature of architecture.
     * In order to get the newly created account, we poll the server to check for new accounts.
     */
    async requestNewListedAccount() {
        const accountsBeforeRequest = await this.getSettingsBasedListedAccounts();
        const response = await this.apiService.registerForListedAccount();
        if (isErrorResponse(response)) {
            return undefined;
        }
        const MaxAttempts = 4;
        const DelayBetweenRequests = 3000;
        for (let i = 0; i < MaxAttempts; i++) {
            const accounts = await this.getSettingsBasedListedAccounts();
            if (accounts.length > accountsBeforeRequest.length) {
                return lastElement(accounts);
            }
            else {
                await sleep(DelayBetweenRequests, false);
            }
        }
        return undefined;
    }
    async getListedAccounts() {
        const settingsBasedAccounts = await this.getSettingsBasedListedAccounts();
        const legacyAccounts = this.getLegacyListedAccounts();
        return [...settingsBasedAccounts, ...legacyAccounts];
    }
    async getListedAccountInfo(account, inContextOfItem) {
        var _a;
        const hostUrl = account.hostUrl;
        let url = `${hostUrl}/authors/${account.authorId}/extension?secret=${account.secret}`;
        if (inContextOfItem) {
            url += `&item_uuid=${inContextOfItem}`;
        }
        const response = (await this.httpSerivce.getAbsolute(url).catch((error) => {
            console.error(error);
        }));
        if (!response || ((_a = response.data) === null || _a === void 0 ? void 0 : _a.error) || !response.data || isString(response.data)) {
            return undefined;
        }
        return response;
    }
    async getSettingsBasedListedAccounts() {
        const response = await this.settingsService.getSetting(SettingName.create(SettingName.NAMES.ListedAuthorSecrets).getValue());
        if (!response) {
            return [];
        }
        const accounts = JSON.parse(response);
        return accounts;
    }
    getLegacyListedAccounts() {
        const extensions = this.itemManager
            .getItems(ContentType.TYPES.ActionsExtension)
            .filter((extension) => extension.isListedExtension);
        const accounts = [];
        for (const extension of extensions) {
            const urlString = extension.url;
            const url = new URL(urlString);
            /** Expected path format: '/authors/647/extension/' */
            const path = url.pathname;
            const authorId = path.split('/')[2];
            /** Expected query string format: '?secret=xxx&type=sn&name=Listed' */
            const queryString = url.search;
            const key = queryString.split('secret=')[1].split('&')[0];
            accounts.push({
                secret: key,
                authorId,
                hostUrl: url.origin,
            });
        }
        return accounts;
    }
}
